import { render, staticRenderFns } from "./NumbersSkeleton.vue?vue&type=template&id=cf9c187c&"
import script from "./NumbersSkeleton.vue?vue&type=script&lang=js&"
export * from "./NumbersSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports